/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconLayoutAlignMiddle = createReactComponent(
  "layout-align-middle",
  "IconLayoutAlignMiddle",
  [
    ["path", { d: "M4 12l5 0", key: "svg-0" }],
    ["path", { d: "M15 12l5 0", key: "svg-1" }],
    [
      "path",
      {
        d: "M9 6m0 2a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v8a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2z",
        key: "svg-2"
      }
    ]
  ]
);

export { IconLayoutAlignMiddle as default };
//# sourceMappingURL=IconLayoutAlignMiddle.js.map
